import React from "react";
import {
  Card,
  CardContent,
  Grid,
  Box,
  Typography,
  Button,
} from "@mui/material";
import DataTable, { Media } from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import { CardHeading, DashboardCard } from "../Common";
import moment from "moment";

const customStyles = {
  rows: {
    style: {
      minHeight: "52px",
      padding: "2%",
    },
  },
  headCells: {
    style: {
      padding: "10px 8px",
      fontSize: "1em",
      fontWeight: "700",
      borderTop: "1px solid black",
      borderBottom: "1px solid black",
      marginBottom: 7,
      maxWidth: "fit-content !important",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "700",
      fontSize: ".82em",
    },
  },
};

const useStyles = makeStyles({
  // heading: {
  //     fontSize: '30 !important',
  //     fontWeight: '800'
  // },
  courseText: {
    fontWeight: "400",
  },
  playerprofilebtn: {
    backgroundColor: "#06623B !important",
    color: "#FFF !important",
    width: 160,
    height: 38,
  },
  tournamentType: {
    backgroundColor: "#06623B",
    color: "#FFF",
    padding: "5% 10%",
    borderRadius: 20,
    minWidth: "38px",
    textAlign: "center",
  },
  tournamentTypeCol: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  // calendarTable: {
  //   color: "Red",
  // },
  datatableSibiling: {
    "& ~ div": {
      // Width
      "&::-webkit-scrollbar": {
        width: "5px",
      },
      // Track
      "&::-webkit-scrollbar-track": {
        background: " #C4C4C4",
        marginTop: "25px",
      },
      // Handle
      "&::-webkit-scrollbar-thumb": {
        background: "#06623B",
        borderTop: "50px solid #C4C4C4",
      },
      // Handle on Hover
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#06623B",
      },
    },
  },
});

function CalendarCard(props) {
  const data = props.calenderEventsData;

  const classes = useStyles();

  const columns = [
    {
      name: "Date",
      selector: (row) => row.date,
      width: "30%",
      cell: (row) => <MatchDateCell row={row} />,
    },
    {
      name: "Tournament",
      selector: (row) => row.tournament,
      cell: (row) => <MatchInfoCell row={row} />,
      width: "70%",
    },
  ];

  const MatchDateCell = ({ row }) => {
    return (
      <Typography variant="ca">
        {moment(row.date).format("D MMMM YYYY")}
      </Typography>
    );
  };
  const MatchInfoCell = ({ row }) => {
    return (
      <Grid container alignItems="center">
        <Grid item xs={9}>
          {/* <div>{row.tournament_name}</div>
          <div className={classes.courseText}>{row.course}</div> */}
          {row.type === "SMP" && (
            <>
              <div>{row.player1}</div>
              vs
              <div>{row.player2}</div>
              <div className={classes.courseText}>{row.course}</div>
            </>
          )}
          {row.type === "DMP" && (
            <>
              <div>{row?.group1.player1}</div>
              <div>{row?.group1.player2}</div>
              vs
              <div>{row?.group2.player1}</div>
              <div>{row?.group2.player2}</div>
              <div className={classes.courseText}>{row.course}</div>
            </>
          )}
          {row.type === "POTY" && (
            <>
              <div>{row.tournament_name}</div>
              <div className={classes.courseText}>{row.course}</div>
            </>
          )}
        </Grid>
        <Grid item xs={3}>
          <MatchTypeCell row={row} />
        </Grid>
      </Grid>
    );
  };

  const MatchTypeCell = ({ row }) => {
    return (
      <div className={classes.tournamentTypeCol}>
        <div className={classes.tournamentType}>{row.type}</div>
      </div>
    );
  };

  return (
    <DashboardCard
      moreButtonText="View More"
      // showMoreButton={data === undefined ? false : true}
      moreButtonColor="alternate"
      showMoreButtonHasIcon={false}
      buttonBG="#06623B"
      viewMoreButtonNoPaddingTop={true}
      showMoreButtonStyle="button"
      innerCardContentNoPadding={true}
      innerCardNoShadow={true}
      showMoreButtonPlacement="right"
      outerCardNoPaddingTop={true}
      onViewMoreClick={() => (window.location.href = "/poty-tournaments")}
    >
      <Box sx={{ marginBottom: 0.8 }} className={classes.datatableSibiling}>
        <CardHeading text="Upcoming Matches" />
      </Box>
      <DataTable
        columns={columns}
        data={data}
        customStyles={customStyles}
        striped={true}
        dense
        fixedHeader={true}
        fixedHeaderScrollHeight={"225px"}
        // className={classes.calendarTable}
      />
    </DashboardCard>
  );
}

export default CalendarCard;
